import instance from '.'
import { err, getResult } from '../utils/functions'
import { APIResult } from '../utils/types'
import { SoloLeaderboardResult, User, UserSoloStats } from './types/users'

export async function createAccount(
  email: string,
  username: string,
  hashPass: string,
  hashCheckPass: string
): Promise<APIResult<string>> {
  return instance
    .post('/api/user/createAccount', {
      email,
      username,
      password: hashPass,
      checkPassword: hashCheckPass,
    })
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function sendResetPasswordEmail(email: string): Promise<APIResult<string>> {
  return instance
    .post('/api/user/sendResetPassEmail', {
      email,
    })
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function resetPassword(
  uuid: string,
  code: string,
  password: string,
  checkPassword: string
): Promise<APIResult<string>> {
  return instance
    .post('/api/user/resetPassword', {
      uuid,
      code,
      password,
      checkPassword,
    })
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function login(email: string, hashPass: string): Promise<APIResult<string>> {
  return instance
    .post('/api/user/login', {
      email,
      password: hashPass,
    })
    .then((res) => getResult<string>(res))
    .catch((e) => getResult<string>(e.response))
}

export async function logout(): Promise<APIResult<string>> {
  return instance
    .post('/api/user/logout')
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function deleteAccount(): Promise<APIResult<string>> {
  return instance
    .post('/api/user/delete')
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function oauthLogin(
  provider: 'google' | 'apple',
  identityToken: string
): Promise<APIResult<string>> {
  return instance
    .post(`/api/user/oauth/${provider}`, { identityToken })
    .catch((e) => err(e))
    .then((res) => getResult<string>(res))
}

export async function getUser(userId: number): Promise<APIResult<User>> {
  return instance
    .get(`/api/user/${userId}`)
    .catch((e) => err(e))
    .then((res) => getResult<User>(res))
}

export async function updateUser(user: User): Promise<APIResult<User>> {
  return instance
    .post(`/api/user/update`, { user })
    .catch((e) => err(e))
    .then((res) => getResult<User>(res))
}

export async function updateUsername(
  username: string
): Promise<
  APIResult<{
    usernameChanged: boolean
    user?: User
    reason?: string
  }>
> {
  return instance
    .post('/api/user/updateUsername', { username })
    .catch((e) => err(e))
    .then((res) =>
      getResult<{
        usernameChanged: boolean
        user?: User
        reason?: string
      }>(res)
    )
}

export async function getSoloStats(): Promise<APIResult<UserSoloStats>> {
  return instance
    .get('/api/user/solo/stats')
    .catch((e) => err(e))
    .then((res) => getResult<UserSoloStats>(res))
}

export async function getSoloLeaderboard(limit?: number): Promise<APIResult<SoloLeaderboardResult>> {
  return instance
    .get('/api/user/solo/leaderboard', {
      params: limit ? { limit } : undefined,
    })
    .catch((e) => err(e))
    .then((res) => getResult<SoloLeaderboardResult>(res))
}

export async function awardSoloPlay(correct: number, total: number): Promise<APIResult<{
  stats: UserSoloStats
  xpAwarded: number
}>> {
  return instance
    .post('/api/user/solo/award', { correct, total })
    .catch((e) => err(e))
    .then((res) =>
      getResult<{
        stats: UserSoloStats
        xpAwarded: number
      }>(res)
    )
}

export async function awardMultiplayerSoloXp(
  correct: number,
  won: boolean
): Promise<
  APIResult<{
    stats: UserSoloStats
    xpAwarded: number
  }>
> {
  return instance
    .post('/api/user/solo/awardMultiplayer', { correct, won })
    .catch((e) => err(e))
    .then((res) =>
      getResult<{
        stats: UserSoloStats
        xpAwarded: number
      }>(res)
    )
}
